import { queryKeys } from '@sshop/api-client';

import { api } from '@/shared/lib/apiClient';
import { defineQuery } from '@/shared/lib/queryFactory';

export const pageSectionsQuery = (pageKey: string) =>
  defineQuery({
    queryKey: queryKeys.pageSection.list(pageKey),
    queryFn: ({ signal }) => api.pageSections.list(pageKey, signal),
    staleTime: 5 * 60_000,
  });
